import axiosProxy from './setting';

export function getInvitations() {
  return axiosProxy({
    LOADING: false,
    url: '/app/users/invitations',
    method: 'get'
  })
}
export function replyInvitation(_id, status) {
  return axiosProxy({
    url: `/app/users/invitations/${_id}/reply`,
    method: 'post',
    data: {
      status
    }
  })
}
export function getChannels(LOADING = false) {
  return axiosProxy({
    LOADING: LOADING,
    url: '/app/channels',
    method: 'get'
  })
}
export function getMessages(channelID, params) {
  return axiosProxy({
    LOADING: false,
    url: `/app/channels/${channelID}`,
    method: 'get',
    params
  })
}
export function getChannelMembers(channelID) {
  return axiosProxy({
    LOADING: false,
    url: `/app/channels/${channelID}/members`,
    method: 'get'
  })
}
export function muteChannel(channelID, action) {
  return axiosProxy({
    url: `/app/channels/${channelID}/mute`,
    method: 'post',
    data: {
      action
    }
  })
}
export function exitChannel(channelID) {
  return axiosProxy({
    url: `/app/channels/${channelID}/exit`,
    method: 'post'
  })
}